<template>
  <div class="container mt-3 pb-6">
    <inertia-head>
      <title>{{ event.title_en }}</title>
    </inertia-head>

    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><inertia-link :href="route('home',)" class="">Home</inertia-link></li>
        <li class="breadcrumb-item"><inertia-link :href="route('plan',)" class="">{{ $trans('raceplan.home.FIND_YOUR_RACE') }}</inertia-link></li>
        <li class="breadcrumb-item active" aria-current="page">{{ event.slug }}</li>
      </ol>
    </nav>
    <div class="feature_header text-center">
      <h3 class="feature_title" id="feature_title" style="margin:0;width:100%">
        <b>{{ event['title_'+this.$locale()] }}</b>
      </h3>
      <h5>
        {{ $trans('track.event.choose_category') }}
      </h5>
    </div>
    <div class="row mt-4" id="category-div">
      <div class="col-sm-6 col-md-4 pt-3" v-for="category in event.event_category" :key="category.id">
          <div class="card h-100 text-center">
            <div class="card-body">
              <h5 class="card-title">{{ category['title_'+this.$locale()] }}</h5>
              <p class="card-text"></p>
              <ul class="list-group list-group-flush">
                <li class="list-group-item">
                  {{  (category.distance/1000).toFixed(2) }} {{ $trans('raceplan.profile.km') }} {{ $trans('raceplan.profile.distance') }}
                </li>
                <li class="list-group-item">
                  {{  (category.incline) }} {{ $trans('track.event.elevation_gain') }}
                </li>
                <li class="list-group-item">
                  <font-awesome-icon :icon="['far', 'calendar-alt']" /> {{ category.start_date }}
                </li>
                <li class="list-group-item">
                  <div class="row">
                    <div class="col-6">
                      <div class="d-grid gap-2">
                        <inertia-link class="btn btn-info" :href="route('events.category_info', [event.slug, category.slug])">
                          {{ $trans('track.event.open_category_btn') }}
                        </inertia-link>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="d-grid gap-2">
                        <inertia-link class="btn btn-primary" :href="route('events.show_category', [event.slug, category.slug])">
                          {{ $trans('raceplan.event_category.plan_your_race') }}
                        </inertia-link>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
      </div>
    </div>

  </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import * as Bootstrap from "bootstrap/dist/js/bootstrap.bundle.min.js"
import { Boarding } from "boarding.js";
import "boarding.js/styles/main.css";
import "boarding.js/styles/themes/basic.css";


export default {
  layout: Layout,
  props: {
    event: Object,
  },
  data() {
    return {
    }
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    let search_uid = urlParams.get('search_uid');
    if(search_uid){
      localStorage.setItem(this.event.slug+"_search_uid", search_uid);
    }

    search_uid = localStorage.getItem(this.event.slug+"_search_uid");
    if(search_uid){

      //const modalEl = document.querySelector('#freePhotoModal')
      //const modal = Bootstrap.Modal.getOrCreateInstance(modalEl)
      //modal.show()

      const boarding = new Boarding();
      boarding.highlight({
        element: "#category-div",
        popover: {
          title: this.$trans('raceplan.event_category.greeting'),
          description: this.$trans('raceplan.event_category.free_photo_instruction1'),
          // prefferedSide can be left, right, top, bottom
          prefferedSide: "top",
          // alignment can be start, center, right
          alignment: "center",
        },
      });
      //boarding.start();
      document.onclick = function(){
        // your code
        if (boarding.isActivated) {
          boarding.reset(false);
        }
      }



    }
  },
  methods: {

  },
}

</script>

<style scoped>

</style>

